<div *ngIf="!loading">
  <input id="folderInput" type="file" (change)="setFiles($event)" />

  <button (click)="importVouchers()">Import Gutscheine</button>
  <button *ngIf="isPreviewed" (click)="clickSubmitVouchers()">
    Speichere Gutscheine
  </button>
</div>
<pre>{{ data | json }}</pre>
